import React from 'react'
import PropTypes from 'prop-types'
import style from './IconButton.less'

const IconButton = ({ icon, onClick }) =>
  <span className={style.main} onClick={onClick}>
    <svg viewBox={icon.viewBox}>
      <use xlinkHref={`#${icon.id}`} />
    </svg>
  </span>

IconButton.propTypes = {
  icon: PropTypes.object.isRequired,
  onClick: PropTypes.func,
}

export default IconButton
